const authorizeUser = async ({ proposalEkey, Cookie }: { proposalEkey: string, Cookie: string }) => {
  const url = `${process.env.HOST_URL}/sdui/api/v1/login`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cookie": Cookie
    },
    body: JSON.stringify({
        proposal_ekey: proposalEkey
    })
  });
  if (!response.ok) {
    throw new Error(`Error in authorize user API`);
  }
  return response.json();
};

export { authorizeUser };